import { Component, Input } from '@angular/core';
import { BaseComponent } from 'src/app/core/infrastructure/classes/base-component';

@Component({
  selector: 'app-comparison-changes',
  templateUrl: './comparison-changes.component.html',
  styleUrls: ['./comparison-changes.component.scss'],
})
export class CompareChangesComponent extends BaseComponent {
  @Input() propertyName: string;
  @Input() currentValue: string | number;
  @Input() newValue: string | number;
  @Input() displayCurrency!: { code: string; symbol: string };
}
